import { errorTracker } from '../utils/errorTracker/tracking';

import type { LongInactivity } from './useInactivityMonitor';

// Temporary: measures how often the inactivity reload happens during the rollout

const STORAGE_KEY = 'inactivity-reload';

interface InactivityReload extends LongInactivity {
  reachabilityRetries: number;
}

/** Stored before reloading and reported by the next page, so the event can't be lost to the reload */
export const rememberInactivityReload = (reload: InactivityReload) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(reload));
  } catch {
    /* storage unavailable → not measured */
  }
};

export const reportInactivityReload = () => {
  let reload: InactivityReload | null;
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!stored) {
      return;
    }
    reload = JSON.parse(stored);
  } catch {
    return;
  }
  if (reload?.reason !== 'asleep' && reload?.reason !== 'away') {
    return;
  }

  const asleep = reload.reason === 'asleep';
  errorTracker.logMessage(asleep ? 'Stale app reloaded after sleep' : 'Stale app reloaded after being away', {
    level: 'info',
    fingerprint: [asleep ? 'inactivity-reload-asleep' : 'inactivity-reload-away'],
    tags: {
      hoursAway: Math.round(reload.hoursAway),
      reachabilityRetries: reload.reachabilityRetries,
      ...(asleep && { wasPlaying: reload.wasPlaying }),
    },
  });
};
